import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SectionHeaderComponent } from '@app/widgets';
import { environment } from '@env/environment';
import { TuiButton } from '@taiga-ui/core';

@Component({
  selector: 'app-app-store-publishing-how-it-works-section',
  imports: [SectionHeaderComponent, TuiButton],
  templateUrl: './app-store-publishing-how-it-works-section.component.html',
  styleUrl: './app-store-publishing-how-it-works-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppStorePublishingHowItWorksSectionComponent {
  protected readonly consoleBaseUrl = environment.consoleBaseUrl;
  protected readonly docsUrl =
    'https://capawesome.io/cloud/app-store-publishing/';
}
